"use client"

import type { Historico } from "@prisma/client"
import { Shield, User } from "lucide-react"
import { useEffect, useRef } from "react"

interface ChatMessagesProps {
  messages: Historico[]
}

export function ChatMessages({ messages }: ChatMessagesProps) {
  const chatContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight
    }
  }, [messages])

  const getRemetente = (tipo: string) => {
    return tipo === "admin" ? "Administrador" : "Denunciante"
  }

  const getMensagensOrdenadas = () => {
    if (!messages) return []
    return [...messages].sort((a, b) =>
      new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    )
  }

  return (
    <div
      ref={chatContainerRef}
      className="space-y-4 max-h-[400px] overflow-y-auto p-4 bg-muted/50 rounded-lg break-words"
    >
      {getMensagensOrdenadas().map((item) => (
        <div
          key={item.id}
          className={`flex items-start gap-3 ${item.tipo === "admin" ? "justify-end" : "justify-start"}`}
        >
          <div
            className={`flex items-start gap-3 p-4 rounded-lg max-w-[80%] overflow-hidden ${item.tipo === "admin"
              ? "bg-primary text-primary-foreground"
              : "bg-muted"
              }`}
          >
            {item.tipo === "admin" ? (
              <Shield className="h-5 w-5 mt-1 flex-shrink-0" />
            ) : (
              <User className="h-5 w-5 mt-1 flex-shrink-0" />
            )}
            <div className="min-w-0 flex-1">
              <p className="text-xs font-medium mb-1">
                {getRemetente(item.tipo)}
              </p>
              <p className="text-sm whitespace-pre-wrap break-words overflow-wrap-anywhere">
                {item.mensagem}
              </p>
              <p className="text-xs opacity-70 mt-1">
                {new Date(item.createdAt).toLocaleString("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
